import {push} from 'react-router-redux';
import {show} from 'react-notification-system-redux';
import {setActiveLanguage} from 'react-localize-redux';

export default function clientMiddleware(client) {
	return ({dispatch, getState}) => {
		return next => action => {
			const {promise, submit, types, setLang, successRedirect, errorRedirect, showNotification, ...rest} = action;
			if (!promise && !submit) {
				return next(action);
			}
			const [REQUEST, SUCCESS, FAILURE] = types;
			if (submit) {
				return submit(client).then(
					(payload) => {
						let token = null;
						if(payload.data){
							token = payload.data.token;
						}

						if(token){
							localStorage.setItem("token",token);
						}

						if(showNotification) {
							const {message} = payload;
							if(message){
								dispatch(show({
									title: "Success",
									message: message
								}, 'success'));
							}
						}

						if(successRedirect){
							next({...rest, payload : { ...action.payload, ...payload}, type: SUCCESS});
							return dispatch(push(successRedirect));
						}else{
							return next({...rest, payload : { ...action.payload, ...payload}, type: SUCCESS});
						}
					},
					(error) => {
						console.log("client middleware -->", error);
						const {message} = error;
						if(message){
							dispatch(show({
								title: "Error",
								message: message
							}, 'error'));
						}

						return next({...rest, error, type: FAILURE});
					},
				);
			} else {
				next({...rest, type: REQUEST});
				return promise(client).then(
					(payload) => {
						let token = null;
						if(payload.data){
							token = payload.data.token;
						}

						if(token){
							localStorage.setItem("token",token);
						}

						if(setLang && payload.data.session.language) {
							if(payload.data.session.language === 'Spanish') {
								dispatch(setActiveLanguage('es'));
							} else {
								dispatch(setActiveLanguage('en'));
							}
						}

						if(successRedirect){
							next({...rest, payload : { ...action.payload, ...payload}, type: SUCCESS});
							return dispatch(push(formatRedirectUrl(successRedirect, action, payload.data)));
						}else {
							return next({...rest, payload : { ...action.payload, ...payload}, type: SUCCESS});
						}
					},
					(error) => {
						console.log("client middleware -->", error);
						if(error.status === 401){
							const {message} = error;
							if(message){
								dispatch(show({
									title: "Error",
									message: message
								}, 'error'));
							}
							if(localStorage.getItem("token")) {
								localStorage.removeItem("token");
								next({...rest, error, type: FAILURE});
								return dispatch(push('/auth/login'));
							}
						}

						if(errorRedirect){
							next({...rest, error, type: FAILURE});
							return dispatch(push(errorRedirect));
						}else{
							return next({...rest, error, type: FAILURE});
						}
					},
				).catch((error) => {
					console.error('MIDDLEWARE ERROR:', error);
					next({...rest, error, type: FAILURE});
				});
			}
		};
	};
};

function strReplaceArray(str, find, replace) {
	let replaceString = str;
	for (let i = 0; i < find.length; i++) {
		replaceString = replaceString.replace(`:${find[i]}`, replace[i]);
	}
	if(replaceString.indexOf("/") !== 0){
		return "/"+replaceString;
	}
	return replaceString;
}

function formatRedirectUrl(urlPattern,action, values ) {
	const { redirectUrlParams } = action;
	if(!redirectUrlParams){
		return urlPattern;
	}
	const findArray = Object.keys(redirectUrlParams);
	const valueKeys = Object.keys(redirectUrlParams).map(item => redirectUrlParams[item]);
	const replaceArray =  valueKeys.map(key => values[key]);
	return strReplaceArray(urlPattern, findArray, replaceArray);
}
